import { makeStyles } from "tss-react/mui-compat"

export const useFiltersBarStyles = makeStyles<{
  mobileFiltersExpanded: boolean 
}>()(
  (theme, props) => ({
    filtersRoot: {
      flexDirection: "column-reverse",
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        paddingTop: theme.spacing(2),
        paddingLeft: "1.25rem",
        paddingRight: "1.25rem",
      },
    },
    filtersRightGroup: {
      flexDirection: "column",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    circularProgressContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",

      width: "100%",
    },
    hideMobile: {
      display: "flex !important",
    },
    hideDesktop: {
      display: "flex !important",
    },
    expandedMobileFilters: {
      width: "100%",
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    mobileFiltersToggleWrapper: {
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "auto",
      },
    },
    mobileFiltersToggle: {
      width: "100%",
      display: "block",
    },
    mobileFilterButton: {
      width: "100%",
      marginTop: theme.spacing(1),
      justifyContent: "flex-start",
    },
    sortButton: {
      marginTop: theme.spacing(1),
      justifyContent: "flex-start",
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(0),
      },
    },
    expandMoreIcon: {
      display: "flex",
      alignItems: "center",
      transform: `rotate(${props.mobileFiltersExpanded ? "180deg" : "0deg"})`,
    },
    expandMoreWrapper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: theme.spacing(2),
      border: "0",
      backgroundColor: "transparent",
      padding: "0",
    },
    searchToolsToggler: {
      display: "flex",
      alignItems: "flex-start",
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      flexDirection: "column",
    },
    searchTools: {
      width: "100%",
    },
    tabTitle: {
      fontFamily: "Lato",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "19px",
    },
    tabsWrapper: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
    },
    tabsWrapperRoot: {
      [theme.breakpoints.up("md")]: {
        width: "50%",
        marginRight: theme.spacing(4),
        alignItems: "center",
      },
    },
  })
)
